import EstablishmentHeader from "./EstablishmentHeader";

import all from "../../../assets/icons/all.svg";
import supermarket from "../../../assets/icons/supermarket.svg";
import food from "../../../assets/icons/reataurants.svg";
import store from "../../../assets/icons/store.svg";
import { useNavigate } from "react-router-dom";

const Estalishments = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-white">
      <div className="md:hidden container mx-auto flex flex-col px-4 py-5 gap-4">
        <div className="text-start font-semibold text-sm">Establishments</div>
        <div className="grid grid-cols-4 gap-3 md:gap-7">
          <EstablishmentHeader
            color="#FFFCF9"
            image={all}
            name="All"
            onClick={() => navigate("/home")}
          />
          <EstablishmentHeader
            color="#FFFCF9"
            image={food}
            name="Restaurant"
            onClick={() => navigate("/restaurant")}
          />
          <EstablishmentHeader
            color="#FFFCF9"
            image={supermarket}
            name="Supermarket"
            onClick={() => navigate("/supermarket")}
          />
          <EstablishmentHeader
            color="#FFFCF9"
            image={store}
            name="Store"
            onClick={() => navigate("/store")}
          />
        </div>
      </div>
    </div>
  );
};

export default Estalishments;
